import React from 'react';
import styles from './style.module.css';

interface BulletListProps {
  items: string[];
  iconType?: string;
}

const BulletList: React.FC<BulletListProps> = ({ items, iconType='arrow' }) => {

  return (
    <div className={`${styles['bullet-list']} ${styles[iconType]}`}>
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            <span className={styles['list-item']}>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BulletList;
